import React, { useEffect, useRef, useState } from "react";
import Contracts from "../../Contracts";
import CardSection from "../../../../components/ui/card/CardSection";
import MolGrid, { Column } from "@moltech/molui/molgrid";
import Checkbox from "../../../../components/ui/inputs/checkBox/CheckBox";
import Buttons from "../../../../components/ui/button/Buttons";
import CustomCenterModel from "../../../../components/ui/customCenterModel/CustomCenterModel";
import { AppIcons } from "../../../../data/appIcons";
import AddPendingContract from "./components/AddPendingContract";
import { useNavigate } from "react-router-dom";
import { useGetMolGridDataMutation } from "../../../../app/services/commonAPI";
import { customRowsPerPageDropdown } from "../../../../components/finalForms/libs/data/dropdownUtilities";

const PendingContracts = () => {

  const gridRef = useRef();
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isExpiredContract, setIsExpiredContract] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (gridRef.current) {
      gridRef.current.reload();
    }
  }, [isExpiredContract])

  const handalCheckboxChange = (e) => {
    setIsExpiredContract(!isExpiredContract);
  };

  const handleCloseModel = () => {
    setIsModelOpen(!isModelOpen);
  };

  const handalSuccessModel = () => {
    handleCloseModel();
    if (gridRef.current) {
      gridRef.current.reload();
    }
  }

  const beforeMolGridLoad = (reqPrm) => {
    const req = {
      pagination: {
        pageNumber: (reqPrm.first / reqPrm.rows) + 1,
        pageSize: reqPrm.rows
      },
      sortField: reqPrm.sortField,
      sortOrder: reqPrm.sortOrder,
      groupBy: reqPrm.groupBy ? reqPrm.groupBy : '',
      plPendingContractKey: 0,
      pbIncludeInactive: isExpiredContract,
      psPendingContractName: null,
    };
    return req;
  }

  const afterMolGridLoad = (data) => {
    return {
      data: data.dataSource,
      count: data.totalRecord
    };
  }

    const handleRowDoubleClick = (event) => {
    navigate(`/EditPendingContracts?pendingContract=${event?.data?.lPendingContractKey}`);
  };

  const getCtxMenuItems = (row) => {
    if (!row) return [];

    return [
      {
        label: "Edit Pending Contract",
        command: () => navigate(`/EditPendingContracts?pendingContract=${row.lPendingContractKey}`),
      },
    ];
  };
  const rowClass = (rowData) => {
    return {
      'red-color-row': rowData.sStatus === "Dead",
    
    };
  };

  const headerContent = () => {
    return (
      <div className="d-flex gap-2">
        <span className="mr-3 d-flex">
          <Checkbox
            label="Show Expired Contracts"
            name="isContract"
            checked={isExpiredContract}
            onChange={handalCheckboxChange}
          />
        </span>
        <Buttons
          buttonText={"Add Contract"}
          buttonTypeClassName="btn blue-btn"
          onClick={() => setIsModelOpen(true)}
        />
      </div>
    );
  };
  return (
    <>
      <div className="scopes-section contract-open-grid">
        <div className="row">
          <div className="table-pb-0 contarct-table ">
            <CardSection
              cardTitle="Pending Contracts"
              customHeader={true}
              headerContent={headerContent()}
            >
              <MolGrid
                ref={gridRef} url="/PendingContract/GetPendingContractsList" client={useGetMolGridDataMutation}
                beforeLoad={beforeMolGridLoad}
                afterLoad={afterMolGridLoad}
                grouping
                expandableRowGroups={true}
                paginator
                rows={99999}
                rowsPerPageOptions={[10, 25, 50, 100]}
                paginatorTemplate={{
                  layout: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                  RowsPerPageDropdown: (options) => {
                    return customRowsPerPageDropdown(options, options?.value)
                  }
                }}

                scrollable
                scrollHeight="flex"
                filterDisplay="row"
                sortMode="single"
                showGridlines
                resizableColumns
                rowClassName={rowClass}
                ctxMenuItems={getCtxMenuItems}
                onRowDoubleClick={handleRowDoubleClick}
              >
                <Column
                  field="sContractType"
                  header="Contract Type"
                  bodyStyle={{ textAlign: "center" }}
                  style={{ width: "17%" }}
                  grouping
                  sortable
                />
                <Column
                  field="sPendingContractName1"
                  header="Pending Contract"
                  bodyStyle={{ textAlign: "left" }}
                  style={{ width: "36%" }}
                  grouping
                  sortable
                />
                <Column
                  field="sClientName1"
                  header="Client"
                  bodyStyle={{ textAlign: "left" }}
                  style={{ width: "30%" }}
                  grouping
                  sortable
                />
                <Column
                  field="salesRep"
                  header="Sales Rep"
                  bodyStyle={{ textAlign: "Center" }}
                  style={{ width: "17%" }}
                  grouping
                  sortable
                />
              </MolGrid>
            </CardSection>
          </div>
        </div>
      </div>
      <CustomCenterModel
        isOpen={isModelOpen}
        useCustomBg={true}
        modalTitle={"Add Contract"}
        contentClass="content-40"
        onClose={handleCloseModel}
        modalTitleIcon={AppIcons.AddIcon}
      >
        <AddPendingContract isOpen={isModelOpen} onClose={handalSuccessModel} />
      </CustomCenterModel>

    </>
  );
};

export default Contracts(PendingContracts);
